import React from "react";

import phoneImg from "../../../assets/images/Dietplan-updated/Rectangle 14182.png";
import bowlImg from "../../../assets/images/Dietplan-updated/f7a8f35f3b26c99c54b9b23c0dd85a15df5229f4.png";
import sparkleIcon from "../../../assets/images/Dietplan-updated/sparkle.svg";
import calorieHeroImg from "../../../assets/images/Dietplan-updated/Plan Screen Image /02.png";

import "./CalorieTrackSection.css";

const SHOW_LEGACY_CALORIE_CARD = false;

const CalorieTrackSection = () => {
  return (
    <div className="diet-calorie-track">
      {SHOW_LEGACY_CALORIE_CARD ? (
        <div className="diet-calorie-track__card" aria-label="Calorie tracking highlight">
          <div className="diet-calorie-track__sparkle" aria-hidden="true">
            <img src={sparkleIcon} alt="" loading="lazy" />
          </div>

          <div className="diet-calorie-track__title">Your Personalised AI Diet Plan</div>

          <div className="diet-calorie-track__content">
            <div className="diet-calorie-track__phoneWrap">
              <img className="diet-calorie-track__phone" src={phoneImg} alt="Nutrition screen preview" loading="lazy" />
            </div>

            <div className="diet-calorie-track__right">
              <div className="diet-calorie-track__kpi">
                <div className="diet-calorie-track__kpiBox">250</div>
                <div className="diet-calorie-track__kpiLabel">Calories</div>
              </div>

              <div className="diet-calorie-track__macros" aria-label="Macros">
                <div className="diet-calorie-track__macro">
                  <span className="diet-calorie-track__bubble diet-calorie-track__bubble--carbs">35g</span>
                  <span className="diet-calorie-track__macroLabel">Carbs</span>
                </div>
                <div className="diet-calorie-track__macro">
                  <span className="diet-calorie-track__bubble diet-calorie-track__bubble--fat">3g</span>
                  <span className="diet-calorie-track__macroLabel">Fat</span>
                </div>
                <div className="diet-calorie-track__macro">
                  <span className="diet-calorie-track__bubble diet-calorie-track__bubble--protein">8g</span>
                  <span className="diet-calorie-track__macroLabel">Protein</span>
                </div>
              </div>

              <div className="diet-calorie-track__cta" aria-hidden="true">
                Wide Variety of Foods
              </div>

              <div className="diet-calorie-track__bowlWrap" aria-hidden="true">
                <img className="diet-calorie-track__bowl" src={bowlImg} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="diet-calorie-track__heroOnlyCard" aria-label="Calorie tracking highlight">
          <img className="diet-calorie-track__heroOnlyImage" src={calorieHeroImg} alt="Calorie tracking preview" loading="lazy" />
        </div>
      )}

      <div className="diet-calorie-track__below">
        <div className="diet-calorie-track__belowTitle">Calorie Tracking</div>
        <div className="diet-calorie-track__belowText">
          Stay on top of your nutrition by making it easy to log the foods you eat and see how many calories you&apos;re
          consuming each day. With a built-in database of meals and ingredients, you can quickly record snacks, drinks,
          and full meals, while the app automatically calculates your totals.
        </div>
      </div>
    </div>
  );
};

export default CalorieTrackSection;

